import { Injectable } from '@angular/core';
import { Http, ManagerResult, ManagerSearch } from 'src/app/shared';

@Injectable({
  providedIn: 'root',
})
export class SearchApi {
  constructor(private http: Http) {}

  getManagers(name: string): Promise<ManagerSearch> {
    return this.http
      .get<ManagerResult[]>(`/api/manager/${name}/manager-list`)
      .then((managers) => new ManagerSearch(name, managers));
  }

  getDelegators(searchFilter: string): Promise<ManagerSearch> {
    return this.http
      .post<ManagerResult[]>('api/delegation/availableDelegators', {
        searchFilter,
      })
      .then((managers) => new ManagerSearch(searchFilter, managers));
  }
}
